exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3CPjlJLjo8eR-WXfB_IrNh{background:#f4f5f7;-webkit-border-radius:1.07143rem;-moz-border-radius:1.07143rem;border-radius:1.07143rem;cursor:pointer;height:2.14286rem;padding:0 .35714rem;position:relative;width:9.28571rem}._3CPjlJLjo8eR-WXfB_IrNh._3G2WK5QqeOIHmpilc3iJcZ{background:#135805}.Qlf_nj0pxDtrccFcFYHGs{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;height:100%;position:relative;width:100%}._2GJ2fQXrvWDrPjWLU_XOxx{background:#fff;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;height:1.42857rem;position:absolute;width:1.42857rem}._2GJ2fQXrvWDrPjWLU_XOxx._3G2WK5QqeOIHmpilc3iJcZ{right:0}._2Ee_kt9q60d7LvHDJbSTnl{color:#a4a4a4;margin:0 auto}._2Ee_kt9q60d7LvHDJbSTnl._3G2WK5QqeOIHmpilc3iJcZ{color:#fff}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SwitchButton": "_3CPjlJLjo8eR-WXfB_IrNh",
	"_selected": "_3G2WK5QqeOIHmpilc3iJcZ",
	"SwitchButton_content": "Qlf_nj0pxDtrccFcFYHGs",
	"SwitchButton_content_circle": "_2GJ2fQXrvWDrPjWLU_XOxx",
	"SwitchButton_content_text": "_2Ee_kt9q60d7LvHDJbSTnl"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/SwitchButton/style.postcss
// module id = 1284
// module chunks = 0